import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import Breadcrumb from "@/components/Breadcrumb";
import blog from "@/data/blog.json";

export default function BlogList() {
  return (
    <>
      <SEO
        title="Blog"
        description="Güzellik, cilt bakımı, lazer epilasyon ve podoloji hakkında uzman kadromuzdan güncel yazılar. Ankara Bağlıca MediEste blog."
        path="/blog"
      />
      <section className="pt-32 pb-6 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Breadcrumb items={[{ label: "Blog" }]} />
      </section>
      <section className="pb-8 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="chip mb-4">Blog</p>
        <h1 className="font-display text-4xl md:text-6xl text-[#0B1B33] leading-[1.05] max-w-3xl mb-6 tracking-tight">Uzman Rehberimiz</h1>
        <p className="text-[#4B5A6E] max-w-2xl leading-relaxed">
          Güzellik, cilt bakımı ve podoloji hakkında güncel bilgiler; uzman kadromuz tarafından hazırlanan yazılar.
        </p>
      </section>
      <section className="pb-32 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12">
          {blog.map((b) => (
            <Link key={b.slug} to={`/${b.slug}`} data-testid={`blog-list-${b.slug}`} className="group block">
              <div className="aspect-[16/10] bg-[#F5F7FA] overflow-hidden mb-5 rounded-2xl">
                {b.image ? (
                  <img src={`/${b.image}`} alt={b.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                ) : null}
              </div>
              <p className="text-[#10B981] text-[10px] tracking-[0.25em] uppercase mb-3 font-bold">Sağlık &amp; Güzellik</p>
              <h3 className="font-display text-xl md:text-2xl text-[#0B1B33] leading-snug mb-3 group-hover:text-[#10B981] transition-colors font-medium">{b.title}</h3>
              <p className="text-[#4B5A6E] text-sm leading-relaxed line-clamp-3">{b.excerpt}</p>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
